import office from '@/taskpane/officejs/office-wrapper'
import sendMessageToSidebar from '../messages/send-message-to-sidebar'
import CallbackArgs, { defaultCallbackArgs } from '../messages/callback-args'
import MessageArgs from '../messages/message-args'
import FilingContents from '../models/filing-contents'

interface RetrieveFilingContentsArgs extends MessageArgs {
  threadId: string
  entityId: string
  autoFile: boolean
  archiveCrm: boolean
  archiveEcm: boolean
  htmlBody: boolean
}

interface RetrieveFilingContentsCallbackArgs extends CallbackArgs {
  threadId: string
  filingContents: FilingContents
}

export default async function retrieveFilingContentsHandler(data: RetrieveFilingContentsArgs) {
  const callbackArgs = defaultCallbackArgs() as RetrieveFilingContentsCallbackArgs

  try {
    callbackArgs.filingContents = await retrieveFilingContents(data)
    callbackArgs.threadId = callbackArgs.filingContents.fileEmailId
    sendMessageToSidebar('RetrieveFilingContentsCallback', callbackArgs)
  } catch (error) {
    callbackArgs.errorCode = 500
    callbackArgs.errorMessage = error || 'Failed to retrieve email info'
    sendMessageToSidebar('RetrieveFilingContentsCallback', callbackArgs)
  }
}

async function retrieveFilingContents(data: RetrieveFilingContentsArgs): Promise<FilingContents> {
  const [subject, from, body, id] = await Promise.all([office.subject.get(), office.mail.from(), office.body.get(!data.htmlBody), office.id()])

  return {
    subject: subject,
    from: from?.emailAddress,
    markdownBody: body,
    priority: '',
    fileEmailId: id,
    fileEmailThreadId: office.mail.conversationId(),
  }
}
